import { Navigate, Outlet } from "react-router-dom";
import cookiesModifier from "../utils/cookies";

// import auth from "../utils/auth";

const AuthRoutes = () => {

    // const tokenValidationRes = auth.isAuthTokenValid();
    const tokenValidationRes = { result: cookiesModifier.getCookie('imm_quest_admin_token') };

    return (
        !tokenValidationRes.result
            ? <Outlet />
            : <Navigate to="/" replace />
    );
};

export default AuthRoutes;